import React, { useState } from "react";
import InputCodice from "../../inputs/InputCodice";
import InputCodiceProd from "../../inputs/InputCodiceProd";
import InputNomeProd from "../../inputs/InputNomeProd";
import mouseIMG from "../../files/img/mouse.webp";
import InputDatoProdotto from "../elementiPagina/InputDatoProdotto";
import DatiUlteriori from "../moduliArticolo/DatiUlteriori";
import Lavorazioni from "../moduliArticolo/Lavorazioni";
import ToolsEReference from "../moduliArticolo/ToolsEReference";
import Traduzione from "../moduliArticolo/Traduzione";
import Debug from "../moduliArticolo/Debug";
import DescHTML from "../moduliArticolo/DescHTML";
import ImmaginiArticolo from "../moduliArticolo/ImmaginiArticolo";
import EditorDescLungaTINYMCE from "../moduliArticolo/EditorDescLungaTINYMCE";
import EditorDescLungaQUILL from "../moduliArticolo/EditorDescLungaQUILL";
import EditorDescLungaSUNEDITOR from "../moduliArticolo/EditorDescLungaSUNEDITOR";
import ImportaTestoOnlineModal, {
  getOnlineTextForLanguage,
  hasTextValue,
} from "./ImportaTestoOnlineModal";

const WORK_TABS = [
  { id: "ToolsEReference", label: "Tools per pubblicazione" },
  { id: "Lavorazioni", label: "Lavorazioni" },
  { id: "Traduzione", label: "Traduzione", permission: "usage:googleapis" },
  { id: "debug", label: "Debug", permission: "read:debug" },
  { id: "syncPS", label: "Sync PS" },
  { id: "DescHTML", label: "HTML desc lunga" },
];

const DETAILS_TABS = [
  { id: "web", label: "Web" },
  { id: "bottero", label: "Bottero", multisite: true },
  { id: "generici", label: "Generico" },
  { id: "calzature", label: "Calzature" },
  { id: "abbigliamento", label: "Abbigliamento" },
  { id: "borseZaini", label: "Borse e zaini" },
  { id: "bike", label: "Bike" },
  { id: "golf", label: "Golf" },
  { id: "sci", label: "Sci" },
  { id: "skiBoots", label: "Scarponi Sci" },
  { id: "snowboardAndBoots", label: "Snowboard e Scarponi" },
  { id: "bastoni", label: "Bastoni" },
  { id: "caschi", label: "Caschi" },
  { id: "occhialiMaschere", label: "Occhiali e maschere" },
  { id: "camping", label: "Camping" },
  { id: "piscinaMare", label: "Piscina Mare" },
  { id: "trekking", label: "Trekking" },
];

const LongDescription = ({
  prodottoTemp,
  lang,
  utente,
  attivaEditor,
  setAttivaEditor,
  handleChangeEditor,
  handleIncollaHtmlDescLunga,
  handleImportaDescLunga,
  prestashopOnline,
  prestashopOnlineLoading,
  prestashopOnlineError,
  buttonClassesWhite,
}) => {
  const [copySite, setCopySite] = useState(null);
  const value = prodottoTemp?.descrizioniSuPS?.descLunga?.[lang] ?? "";
  const dominoShortHtml =
    prodottoTemp?.descrizioniSuPS?.descBreve?.[lang] ?? "";
  const sourceHtmlBySite = {
    VIG: getOnlineTextForLanguage(
      prestashopOnline,
      "VIG",
      "descriptionLong",
      lang,
    ),
    BOT: getOnlineTextForLanguage(
      prestashopOnline,
      "BOT",
      "descriptionShort",
      lang,
    ),
  };
  const sourceTitleBySite = {
    VIG: "Descrizione lunga online VIG",
    BOT: "Descrizione breve online BOT",
  };
  const disabledReason = (site) => {
    if (hasTextValue(value)) {
      return "La descrizione lunga Domino è già presente nella lingua corrente.";
    }
    if (prestashopOnlineLoading) return "Lettura dei dati online in corso.";
    if (prestashopOnlineError) return prestashopOnlineError;
    if (!prestashopOnline?.sites?.[site]?.available) {
      return (
        prestashopOnline?.sites?.[site]?.unavailableMessage ||
        `Il sito ${site} non è interrogabile per questo articolo.`
      );
    }
    if (!hasTextValue(sourceHtmlBySite[site])) {
      return site === "VIG"
        ? "Su VIG non c’è una descrizione lunga nella lingua corrente."
        : "Su BOT non c’è una descrizione breve nella lingua corrente.";
    }
    return "";
  };
  const selectedSourceHtml = copySite ? sourceHtmlBySite[copySite] : "";

  return (
    <div className="colonna2-l fl-l w-100 w-70-ns w-50-l pt2 pb2 pl2 pr2 pl4-l pr4-l">
      <div className="colonna85vh mt3 flex flex-column">
        {!attivaEditor && (
          <div className="modificaProdottiLongDescriptionToolbar flex flex-wrap items-center">
            <button
              type="button"
              className={`${buttonClassesWhite} mr2 mb2`}
              onClick={() => setAttivaEditor(true)}
            >
              <span className="material-icons colAltScuro">edit</span>
            </button>
            <button
              type="button"
              className={`${buttonClassesWhite} mr2 mb2`}
              onClick={handleIncollaHtmlDescLunga}
            >
              Incolla HTML
            </button>
            {["VIG", "BOT"].map((site) => {
              const reason = disabledReason(site);
              return (
                <button
                  key={site}
                  type="button"
                  className={`${buttonClassesWhite} modificaProdottiImportaTestoButton mr2 mb2`}
                  disabled={Boolean(reason)}
                  title={reason}
                  aria-label={"Copia da " + site}
                  onClick={() => setCopySite(site)}
                >
                  Copia da {site}
                </button>
              );
            })}
          </div>
        )}
        <div
          className={
            attivaEditor
              ? "modificaProdottiLongDescriptionEditor"
              : "modificaProdottiLongDescriptionPreview sezioneConScroll"
          }
        >
          {utente.textEditor === "tinyMCE" && attivaEditor && (
            <EditorDescLungaTINYMCE
              nuovaDesc={!value}
              initialValue={value ? undefined : ""}
              value={value}
              handleChangeEditor={handleChangeEditor}
            />
          )}
          {utente.textEditor === "quill" && attivaEditor && (
            <EditorDescLungaQUILL
              nuovaDesc={!value}
              initialValue={value ? undefined : ""}
              value={value}
              handleChangeEditor={handleChangeEditor}
            />
          )}
          {utente.textEditor === "sun" && attivaEditor && (
            <EditorDescLungaSUNEDITOR
              nuovaDesc={false}
              value={value}
              handleChangeEditor={handleChangeEditor}
            />
          )}
          {value && !attivaEditor && (
            <div
              className="pb2 bb bordoColAlt pr4"
              dangerouslySetInnerHTML={{ __html: value }}
            />
          )}
        </div>
      </div>
      <ImportaTestoOnlineModal
        open={Boolean(copySite)}
        sourceTitle={copySite ? sourceTitleBySite[copySite] : ""}
        sourceHtml={selectedSourceHtml}
        dominoShortHtml={dominoShortHtml}
        targetLabel="Descrizione lunga"
        onUse={(html) => {
          handleImportaDescLunga(html);
          setCopySite(null);
        }}
        onClose={() => setCopySite(null)}
        buttonClassesWhite={buttonClassesWhite}
      />
    </div>
  );
};

const DescriptionTabs = ({
  tab,
  setTab,
  utente,
  canViewMultisiteSupport,
  selectedClass,
  defaultClass,
}) => {
  const renderTab = ({ id, label, permission, multisite }) => {
    if (permission && !utente.permessiAPI[permission]) return null;
    if (multisite && !canViewMultisiteSupport) return null;
    return (
      <button
        key={id}
        type="button"
        className={`${tab === id ? selectedClass : defaultClass} modificaProdottiVerticalTab`}
        onClick={() => setTab(id)}
        aria-current={tab === id ? "page" : undefined}
      >
        {label}
      </button>
    );
  };

  return (
    <nav className="colonna3-l fl-l w-100 w-30-ns w-10-l pt2 pb2 pl2 colonna90vh bordoColAlt relative sezioneConScroll">
      <h3>Schede</h3>
      {WORK_TABS.map(renderTab)}
      <h3>Dati ulteriori</h3>
      {DETAILS_TABS.map(renderTab)}
      <div className="tr inFondo">
        {(utente.nomeDisplayAlt === "Manu" ||
          utente.nomeDisplayAlt === "Ribes") && (
          <img alt="topo" className="w-70" src={mouseIMG} />
        )}
      </div>
    </nav>
  );
};

const DetailsPanel = ({
  prodottoTemp,
  setProdottoTemp,
  prodottoRiferimento,
  setProdottoRiferimento,
  lang,
  utente,
  tab,
  canViewMultisiteSupport,
  datiUlterioriStandard,
  avvisoSpedizione,
  prestashopOnline,
  appuntiProdottoValue,
  listaNomiProdotto,
  handleChangeAppProd,
  handleReferenceSearchResults,
  handleChange,
  handleChangeDatoUlteriore,
  handleChangeColoreSel,
  handleChangeColoreNonSel,
  handleChangeSciancratura,
  traduci,
  inputClasses,
  inputClassesConDueTasti,
  buttonClassesWhite,
  buttonClassesRed,
  classiTastoCopiaInAlto,
  classiTastoSblocco,
  token,
  auditUsername,
  modaBrandCode,
  onImmaginiCopiate,
}) => {
  const commonDatiUlterioriProps = {
    avvisoSpedizione,
    datoOnChange: handleChangeDatoUlteriore,
    colSelChange: handleChangeColoreSel,
    colNonSelChange: handleChangeColoreNonSel,
    inputClasses,
    datoClass: inputClassesConDueTasti,
    prodottoTemp,
    handleChangeSciancratura,
    prestashopOnline,
    showOnlineFeatureReferences: canViewMultisiteSupport,
  };
  const isGenericDetailsTab =
    !WORK_TABS.some((item) => item.id === tab) && tab !== "generici";

  return (
    <div className="colonna4-l fl-l w-100 w-70-ns w-20-l pt4 pb2 pl2 pr2 pl4-l colonna90vh sezioneConScroll bl-ns bordoColAlt">
      {tab === "Lavorazioni" && (
        <Lavorazioni
          utente={utente}
          prodottoTemp={prodottoTemp}
          appuntiProdottoValue={appuntiProdottoValue}
          handleChangeAppProd={handleChangeAppProd}
          inputClasses={inputClasses}
          traduci={traduci}
          buttonClassesWhite={buttonClassesWhite}
        />
      )}
      {tab === "ToolsEReference" && (
        <div>
          {prodottoTemp.codicePS && (
            <ImmaginiArticolo
              prodIDps={prodottoTemp.codicePS}
              size="home_default"
            />
          )}
          <ToolsEReference
            prodottoTemp={prodottoTemp}
            setProdottoTemp={setProdottoTemp}
            setProdottoRiferimento={setProdottoRiferimento}
            classiTastoCopiaInAlto={classiTastoCopiaInAlto}
            prodottoRiferimento={prodottoRiferimento}
            InputCodice={InputCodice}
            InputCodiceProd={InputCodiceProd}
            InputNomeProd={InputNomeProd}
            lang={lang}
            classiTastoSblocco={classiTastoSblocco}
            listaNomiProdotto={listaNomiProdotto}
            utente={utente}
            onReferenceSearchResults={handleReferenceSearchResults}
            token={token}
            auditUsername={auditUsername}
            modaBrandCode={modaBrandCode}
            onImmaginiCopiate={onImmaginiCopiate}
          />
        </div>
      )}
      {tab === "DescHTML" && (
        <DescHTML
          prodottoTemp={prodottoTemp}
          handleChange={handleChange}
          datoClass={inputClassesConDueTasti}
          lang={lang}
          datoValue={prodottoTemp.descrizioniSuPS.descLunga[lang]}
        />
      )}
      {utente.permessiAPI["usage:googleapis"] && tab === "Traduzione" && (
        <Traduzione
          utente={utente}
          prodottoTemp={prodottoTemp}
          traduci={traduci}
          buttonClassesWhite={buttonClassesWhite}
        />
      )}
      {tab === "debug" && (
        <Debug
          prodottoTemp={prodottoTemp}
          datoOnChange={handleChange}
          datoClass={inputClassesConDueTasti}
        />
      )}
      {tab === "syncPS" && (
        <div>
          <p>
            La sincronizzazione con Prestashop usa questo ID. Se ricrei
            l’articolo, aggiorna il campo con il nuovo valore.
          </p>
          <InputDatoProdotto
            inputLabel="ID Prestashop"
            datoName="codicePS"
            datoId="codicePS"
            datoValue={prodottoTemp?.codicePS ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            datoClass={inputClasses}
            classiTastoSblocco="dn"
            tastoCopiaAspetto="dn"
          />
        </div>
      )}
      {tab === "generici" && (
        <div>
          <DatiUlteriori
            tab="generici"
            datiUlterioriTab={datiUlterioriStandard.generici}
            {...commonDatiUlterioriProps}
          />
          {prodottoTemp.codicePS && (
            <ImmaginiArticolo
              prodIDps={prodottoTemp.codicePS}
              size="medium_default"
            />
          )}
        </div>
      )}
      {isGenericDetailsTab &&
        (tab !== "bottero" || canViewMultisiteSupport) && (
          <DatiUlteriori
            tab={tab}
            datiUlterioriTab={datiUlterioriStandard[tab]}
            {...commonDatiUlterioriProps}
          />
        )}
    </div>
  );
};

function Descrizioni({ product, editor, navigation, data, actions, ui }) {
  return (
    <section className="modificaProdottiPagina">
      <div className="modificaProdottiAreaPrincipale flex flex-wrap">
        <LongDescription
          prodottoTemp={product.prodottoTemp}
          lang={product.lang}
          utente={product.utente}
          attivaEditor={editor.attivaEditor}
          setAttivaEditor={editor.setAttivaEditor}
          handleChangeEditor={editor.handleChangeEditor}
          handleIncollaHtmlDescLunga={editor.handleIncollaHtmlDescLunga}
          handleImportaDescLunga={editor.handleImportaDescLunga}
          prestashopOnline={data.prestashopOnline}
          prestashopOnlineLoading={data.prestashopOnlineLoading}
          prestashopOnlineError={data.prestashopOnlineError}
          buttonClassesWhite={ui.buttonClassesWhite}
        />
        <DescriptionTabs
          tab={navigation.tab}
          setTab={navigation.setTab}
          utente={product.utente}
          canViewMultisiteSupport={navigation.canViewMultisiteSupport}
          selectedClass={ui.vociMenuTabsSelezionata}
          defaultClass={ui.vociMenuTabs}
        />
        <DetailsPanel
          {...product}
          {...data}
          {...actions}
          {...ui}
          tab={navigation.tab}
          canViewMultisiteSupport={navigation.canViewMultisiteSupport}
        />
      </div>
    </section>
  );
}

export default Descrizioni;
